import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/theme/liga-logo-white.png'


const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "video-speed-label" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "video-player-wrap" }
const _hoisted_6 = ["controls"]
const _hoisted_7 = ["src", "type"]
const _hoisted_8 = {
  class: "education-hold-2x-hint",
  "aria-hidden": "true"
}
const _hoisted_9 = { class: "video-player-loader" }
const _hoisted_10 = { class: "next-video-countdown-overlay-text" }
const _hoisted_11 = {
  key: 2,
  class: "video-controls-bar"
}
const _hoisted_12 = ["aria-label"]
const _hoisted_13 = { class: "video-controls-progress-track" }
const _hoisted_14 = { class: "video-controls-time" }
const _hoisted_15 = {
  key: 0,
  class: "player-strip-wrap"
}
const _hoisted_16 = {
  class: "player-strip-scroll",
  ref: "playerStripRef"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "player-strip-title" }
const _hoisted_19 = {
  key: 0,
  class: "skills-loading-state skills-loading-initial"
}
const _hoisted_20 = { class: "section-select-wrap" }
const _hoisted_21 = {
  class: "section-chips-scroll",
  ref: "sectionScrollRef"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "education-tab-wrap" }
const _hoisted_24 = { class: "video-list-wrapper" }
const _hoisted_25 = {
  key: 0,
  class: "skills-loading-state"
}
const _hoisted_26 = {
  key: 0,
  class: "video-grid"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "video-thumbnail" }
const _hoisted_29 = { class: "play-overlay" }
const _hoisted_30 = {
  key: 0,
  class: "play-button"
}
const _hoisted_31 = {
  key: 0,
  class: "video-watch-progress-bar"
}
const _hoisted_32 = { class: "video-watch-progress-pct" }
const _hoisted_33 = {
  key: 2,
  class: "single-video-progress-bar"
}
const _hoisted_34 = { class: "single-video-progress-track" }
const _hoisted_35 = { class: "single-video-progress-pct" }
const _hoisted_36 = { class: "video-info" }
const _hoisted_37 = { class: "video-title" }
const _hoisted_38 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_39 = { class: "materials-list-wrapper" }
const _hoisted_40 = {
  key: 0,
  class: "skills-loading-state"
}
const _hoisted_41 = {
  key: 0,
  class: "materials-list"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "material-icon-wrap" }
const _hoisted_44 = { class: "material-info" }
const _hoisted_45 = { class: "material-title" }
const _hoisted_46 = { class: "material-meta" }
const _hoisted_47 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_48 = {
  key: 0,
  class: "pdf-download-overlay"
}
const _hoisted_49 = { class: "pdf-download-card" }
const _hoisted_50 = { class: "pdf-download-percent" }
const _hoisted_51 = {
  key: 0,
  class: "pdf-viewer-pdfjs"
}
const _hoisted_52 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_PageHeaderWithMenu = _resolveComponent("PageHeaderWithMenu")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_VuePdfEmbed = _resolveComponent("VuePdfEmbed")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        class: "video-overlay",
        onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.exitVideoPlayer && _ctx.exitVideoPlayer(...args)))
      }, [
        _createElementVNode("div", {
          ref: "videoContainerRef",
          class: _normalizeClass([
          'video-container',
          { 'video-container--pseudo-fullscreen': _ctx.isVideoContainerFullscreen && _ctx.usePseudoFullscreen },
          { 'video-container--native-chrome': _ctx.usePseudoFullscreen },
        ]),
          onClick: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["video-overlay-buttons", { 'video-overlay-buttons--hidden': _ctx.usePseudoFullscreen && !_ctx.videoChromeVisible }]),
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.bumpVideoChromeHideTimer && _ctx.bumpVideoChromeHideTimer(...args)), ["stop"]))
          }, [
            _createElementVNode("button", {
              type: "button",
              class: "close-button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exitVideoPlayer && _ctx.exitVideoPlayer(...args))),
              "aria-label": "Закрыть"
            }, [
              _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "fullscreen-toggle-button",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleVideoFullscreen && _ctx.toggleVideoFullscreen(...args)), ["stop"])),
              "aria-label": _ctx.isVideoContainerFullscreen ? 'Выйти из полноэкранного режима' : 'Полный экран'
            }, [
              _createVNode(_component_ion_icon, {
                icon: _ctx.isVideoContainerFullscreen ? _ctx.contractOutline : _ctx.expandOutline
              }, null, 8, ["icon"])
            ], 8, _hoisted_1),
            _createElementVNode("button", {
              type: "button",
              class: "video-speed-button",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cyclePlaybackRate && _ctx.cyclePlaybackRate(...args)), ["stop"])),
              "aria-label": 'Скорость ' + _ctx.videoPlaybackRate + 'x'
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.videoPlaybackRate) + "x", 1)
            ], 8, _hoisted_2),
            _createElementVNode("button", {
              type: "button",
              class: "video-mirror-button",
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleVideoMirror && _ctx.toggleVideoMirror(...args)), ["stop"])),
              "aria-label": _ctx.videoMirror ? 'Выключить зеркало' : 'Зеркальное отображение'
            }, [
              _createVNode(_component_ion_icon, { icon: _ctx.swapHorizontalOutline }, null, 8, ["icon"])
            ], 8, _hoisted_4)
          ], 2),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("video", {
              ref: "videoPlayer",
              class: _normalizeClass({ 'video-mirror': _ctx.videoMirror }),
              oncontextmenu: "return false;",
              preload: "auto",
              autoPictureInPicture: "true",
              playsinline: "",
              "webkit-playsinline": "",
              "x-webkit-airplay": "allow",
              controls: !_ctx.useCustomVideoControls,
              crossorigin: "anonymous",
              onLoadedmetadata: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onVideoLoaded && _ctx.onVideoLoaded(...args))),
              onCanplay: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onVideoCanplay && _ctx.onVideoCanplay(...args))),
              onTimeupdate: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onTimeUpdate && _ctx.onTimeUpdate(...args))),
              onWaiting: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onVideoWaiting && _ctx.onVideoWaiting(...args))),
              onPlaying: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onVideoPlaying && _ctx.onVideoPlaying(...args))),
              onPause: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onVideoPaused && _ctx.onVideoPaused(...args))),
              onEnded: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onVideoEnded && _ctx.onVideoEnded(...args))),
              onError: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onVideoError && _ctx.onVideoError(...args)))
            }, [
              _createElementVNode("source", {
                src: _ctx.trackPath,
                type: _ctx.trackPath.endsWith('m3u8')
              ? 'application/x-mpegURL'
              : 'video/mp4'
              
              }, null, 8, _hoisted_7)
            ], 42, _hoisted_6),
            (_ctx.usePseudoFullscreen && !_ctx.videoChromeVisible)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "video-chrome-hitlayer",
                  "aria-label": "Показать панель управления",
                  onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showVideoChromeFromVideoTap && _ctx.showVideoChromeFromVideoTap(...args)), ["stop"]))
                }))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", {
              class: _normalizeClass(['video-hold-2x-zone', _ctx.useCustomVideoControls ? 'video-hold-2x-zone--web' : 'video-hold-2x-zone--native']),
              "aria-hidden": "true",
              onPointerdown: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.onEducationHold2xPointerDown($event)), ["prevent","stop"])),
              onPointerup: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.onEducationHold2xPointerUp($event)), ["stop"])),
              onPointercancel: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.onEducationHold2xPointerCancel($event)), ["stop"]))
            }, null, 34), [
              [_vShow, _ctx.showVideoPlayer]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_8, [
              _createVNode(_component_ion_icon, {
                icon: _ctx.playForward,
                class: "education-hold-2x-hint-icon"
              }, null, 8, ["icon"]),
              _cache[32] || (_cache[32] = _createElementVNode("span", { class: "education-hold-2x-badge" }, "2×", -1)),
              _createVNode(_component_ion_icon, {
                icon: _ctx.playForward,
                class: "education-hold-2x-hint-icon"
              }, null, 8, ["icon"])
            ], 512), [
              [_vShow, _ctx.educationHold2xHint]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_9, [
              _createVNode(_component_ion_spinner, {
                name: "bubbles",
                class: "video-player-loader-spinner"
              }),
              _cache[33] || (_cache[33] = _createElementVNode("p", { class: "video-player-loader-text" }, "Подготовка воспроизведения...", -1))
            ], 512), [
              [_vShow, _ctx.videoLoading]
            ]),
            (_ctx.nextVideoCountdown >= 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "next-video-countdown-overlay",
                  onClick: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancelNextVideo && _ctx.cancelNextVideo(...args)), ["stop"]))
                }, [
                  _createElementVNode("p", _hoisted_10, "Следующее видео через " + _toDisplayString(_ctx.nextVideoCountdown), 1),
                  _cache[34] || (_cache[34] = _createElementVNode("button", {
                    type: "button",
                    class: "next-video-countdown-cancel-btn"
                  }, "Отмена", -1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.useCustomVideoControls)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "video-controls-play",
                    onClick: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleVideoPlayPause && _ctx.toggleVideoPlayPause(...args)), ["stop"])),
                    "aria-label": _ctx.isVideoPlaying ? 'Пауза' : 'Воспроизведение'
                  }, [
                    (_openBlock(), _createBlock(_component_ion_icon, {
                      key: _ctx.isVideoPlaying ? 'pause' : 'play',
                      icon: _ctx.isVideoPlaying ? _ctx.pause : _ctx.play
                    }, null, 8, ["icon"]))
                  ], 8, _hoisted_12),
                  _createElementVNode("div", {
                    class: "video-controls-progress-wrap",
                    onClick: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onVideoProgressClick && _ctx.onVideoProgressClick(...args)), ["stop"]))
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", {
                        class: "video-controls-progress-fill",
                        style: _normalizeStyle({ width: _ctx.videoProgressPercent + '%' })
                      }, null, 4)
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.formatVideoControlTime(_ctx.videoControlCurrentTime)) + " / " + _toDisplayString(_ctx.formatVideoControlTime(_ctx.videoControlDuration)), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.currentVideoList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentVideoList, (video) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: video.id,
                      type: "button",
                      class: _normalizeClass(["player-strip-item", { 'player-strip-item--active': video.id === _ctx.selectedId }]),
                      onClick: ($event: any) => (_ctx.selectVideo(video.id))
                    }, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.formatVideoTitle(video.name)), 1)
                    ], 10, _hoisted_17))
                  }), 128))
                ], 512)
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ], 512), [
        [_vShow, _ctx.showVideoPlayer]
      ]),
      _createVNode(_component_PageHeaderWithMenu, {
        title: _ctx.pageTitleText,
        scrolled: _ctx.headerScrolled
      }, null, 8, ["title", "scrolled"]),
      _createVNode(_component_ion_content, {
        class: "main-background skills-content",
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          (_ctx.skillsListLoading && _ctx.visibleSections.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(_component_ion_spinner, {
                  name: "bubbles",
                  class: "skills-loading-spinner"
                }),
                _cache[35] || (_cache[35] = _createElementVNode("p", { class: "skills-loading-text" }, "Загрузка...", -1))
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleSections, (s) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: s.folderKey,
                  type: "button",
                  class: _normalizeClass(["section-chip", { 'section-chip--active': _ctx.selectedSectionKey === s.folderKey }]),
                  onClick: ($event: any) => (_ctx.selectedSectionKey = s.folderKey)
                }, _toDisplayString(s.name), 11, _hoisted_22))
              }), 128))
            ], 512)
          ], 512), [
            [_vShow, _ctx.visibleSections.length > 0]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_23, [
            _createVNode(_component_ion_segment, {
              value: _ctx.educationTab,
              onIonChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onEducationTabChange($event))),
              mode: "ios",
              class: "liga-glass-segment education-tab-segment"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_segment_button, {
                  mode: "ios",
                  value: "video"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                        _createTextVNode("Видео", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, {
                  mode: "ios",
                  value: "materials"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                        _createTextVNode("Обучающие материалы", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ], 512), [
            [_vShow, _ctx.selectedSectionKey]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_24, [
            _createVNode(_component_ion_refresher, {
              slot: "fixed",
              onIonRefresh: _cache[23] || (_cache[23] = ($event: any) => (_ctx.reloadSkills($event)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_refresher_content, { refreshingSpinner: "bubbles" })
              ]),
              _: 1
            }),
            (_ctx.skillsListLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createVNode(_component_ion_spinner, {
                    name: "bubbles",
                    class: "skills-loading-spinner"
                  }),
                  _cache[38] || (_cache[38] = _createElementVNode("p", { class: "skills-loading-text" }, "Загрузка списка...", -1))
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.currentVideoList.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentVideoList, (video) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: video.id,
                            class: "video-card",
                            onClick: ($event: any) => (_ctx.selectVideo(video.id))
                          }, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                (video.id !== _ctx.selectedId || !_ctx.videoLoading)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                      _createVNode(_component_ion_icon, { icon: _ctx.play }, null, 8, ["icon"])
                                    ]))
                                  : (_openBlock(), _createBlock(_component_ion_spinner, {
                                      key: 1,
                                      name: "bubbles",
                                      class: "loading-spinner"
                                    }))
                              ]),
                              _cache[39] || (_cache[39] = _createElementVNode("div", { class: "thumbnail-gradient" }, null, -1)),
                              _cache[40] || (_cache[40] = _createElementVNode("img", {
                                src: _imports_0,
                                alt: "liga-logo",
                                class: "video-logo"
                              }, null, -1)),
                              (_ctx.getVideoWatchPercent(video.id) != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _createElementVNode("div", {
                                      class: "video-watch-progress-fill",
                                      style: _normalizeStyle({ width: `${_ctx.getVideoWatchPercent(video.id)}%` })
                                    }, null, 4),
                                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.getVideoWatchPercent(video.id)) + "%", 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.educationOfflineService.isMobile())
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "video-offline-badge",
                                    onClick: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["stop"]))
                                  }, [
                                    _withDirectives(_createVNode(_component_ion_button, {
                                      fill: "clear",
                                      class: "video-offline-btn",
                                      onClick: ($event: any) => (_ctx.downloadVideo(video)),
                                      title: "Сохранить для оффлайн"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: _ctx.cloudDownloadOutline }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]), [
                                      [_vShow, !_ctx.isVideoOffline(video.id) && !_ctx.isVideoDownloading(video.id)]
                                    ]),
                                    _withDirectives(_createVNode(_component_ion_button, {
                                      fill: "clear",
                                      class: "video-offline-btn",
                                      onClick: ($event: any) => (_ctx.stopVideoDownload(video)),
                                      title: "Остановить загрузку"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: _ctx.stopCircle }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]), [
                                      [_vShow, _ctx.isVideoDownloading(video.id)]
                                    ]),
                                    _withDirectives(_createVNode(_component_ion_button, {
                                      fill: "clear",
                                      class: "video-offline-btn video-offline-done",
                                      onClick: ($event: any) => (_ctx.removeVideo(video)),
                                      title: "Удалить оффлайн"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: _ctx.trash }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]), [
                                      [_vShow, _ctx.isVideoOffline(video.id) && !_ctx.isVideoDownloading(video.id)]
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.isVideoDownloading(video.id))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _createElementVNode("div", _hoisted_34, [
                                      _createElementVNode("div", {
                                        class: "single-video-progress-fill",
                                        style: _normalizeStyle({ width: `${_ctx.singleVideoProgress.get(video.id)?.percentage ?? 0}%` })
                                      }, null, 4)
                                    ]),
                                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.singleVideoProgress.get(video.id)?.percentage ?? 0) + "%", 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("h3", _hoisted_37, _toDisplayString(_ctx.formatVideoTitle(video.name)), 1)
                            ])
                          ], 8, _hoisted_27))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createVNode(_component_ion_icon, {
                          icon: _ctx.filmOutline,
                          class: "empty-icon"
                        }, null, 8, ["icon"]),
                        _cache[41] || (_cache[41] = _createElementVNode("p", null, "Нет доступных видео", -1))
                      ]))
                ], 64))
          ], 512), [
            [_vShow, _ctx.selectedSectionKey && _ctx.educationTab === 'video']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_39, [
            _createVNode(_component_ion_refresher, {
              slot: "fixed",
              onIonRefresh: _cache[25] || (_cache[25] = ($event: any) => (_ctx.reloadSkills($event)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_refresher_content, { refreshingSpinner: "bubbles" })
              ]),
              _: 1
            }),
            (_ctx.skillsListLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createVNode(_component_ion_spinner, {
                    name: "bubbles",
                    class: "skills-loading-spinner"
                  }),
                  _cache[42] || (_cache[42] = _createElementVNode("p", { class: "skills-loading-text" }, "Загрузка материалов...", -1))
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.currentPdfList.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentPdfList, (pdf) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: pdf.id,
                            class: "material-card",
                            onClick: ($event: any) => (_ctx.openPdfOrDownload(pdf))
                          }, [
                            _createElementVNode("div", _hoisted_43, [
                              _createVNode(_component_ion_icon, {
                                icon: _ctx.documentTextOutline,
                                class: "material-icon"
                              }, null, 8, ["icon"])
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("h3", _hoisted_45, _toDisplayString(pdf.displayName), 1),
                              _createElementVNode("p", _hoisted_46, _toDisplayString(pdf.sectionName || pdf.sectionFolderKey), 1)
                            ]),
                            _createVNode(_component_ion_button, {
                              fill: "clear",
                              size: "small",
                              class: _normalizeClass(['material-download-btn', { 'material-download-btn--disabled': !_ctx.isPdfDownloadAllowed(pdf) }]),
                              onClick: _withModifiers(($event: any) => (_ctx.downloadPdf(pdf)), ["stop"]),
                              title: _ctx.isPdfDownloadAllowed(pdf) ? 'Скачать PDF' : 'Скачивание недоступно'
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "icon-only",
                                  icon: _ctx.cloudDownloadOutline
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            }, 8, ["class", "onClick", "title"])
                          ], 8, _hoisted_42))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        _createVNode(_component_ion_icon, {
                          icon: _ctx.documentOutline,
                          class: "empty-icon"
                        }, null, 8, ["icon"]),
                        _cache[43] || (_cache[43] = _createElementVNode("p", null, "Нет обучающих материалов", -1))
                      ]))
                ], 64))
          ], 512), [
            [_vShow, _ctx.selectedSectionKey && _ctx.educationTab === 'materials']
          ])
        ]),
        _: 1
      }, 8, ["onIonScroll"]),
      (_ctx.pdfDownloading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _cache[44] || (_cache[44] = _createElementVNode("p", { class: "pdf-download-title" }, "Скачивание PDF", -1)),
              _createVNode(_component_ion_progress_bar, {
                value: _ctx.pdfDownloadProgress / 100,
                type: "determinate"
              }, null, 8, ["value"]),
              _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.pdfDownloadProgress) + "%", 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", {
        class: "pdf-viewer-overlay",
        onContextmenu: _cache[30] || (_cache[30] = _withModifiers(() => {}, ["prevent"])),
        onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.closePdfViewer && _ctx.closePdfViewer(...args)))
      }, [
        _createElementVNode("div", {
          class: "pdf-viewer-container",
          onClick: _cache[28] || (_cache[28] = _withModifiers(() => {}, ["stop"])),
          onContextmenu: _cache[29] || (_cache[29] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "pdf-viewer-close",
            onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.closePdfViewer && _ctx.closePdfViewer(...args))),
            "aria-label": "Закрыть"
          }, [
            _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
          ]),
          (_ctx.pdfViewerUrl)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.usePdfJsViewer)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      _createVNode(_component_VuePdfEmbed, {
                        source: _ctx.pdfViewerUrl,
                        "annotation-layer": "",
                        "text-layer": ""
                      }, null, 8, ["source"])
                    ]))
                  : (_openBlock(), _createElementBlock("iframe", {
                      key: 1,
                      src: _ctx.pdfViewerUrl,
                      class: "pdf-viewer-iframe",
                      title: "Просмотр PDF",
                      onContextmenu: _cache[27] || (_cache[27] = _withModifiers(() => {}, ["prevent"]))
                    }, null, 40, _hoisted_52))
              ], 64))
            : (_openBlock(), _createBlock(_component_ion_spinner, {
                key: 1,
                name: "bubbles",
                class: "pdf-viewer-spinner"
              }))
        ], 32)
      ], 544), [
        [_vShow, _ctx.showPdfViewer]
      ])
    ]),
    _: 1
  }))
}